// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddLanguagePopup_wrapper__1fb2z","select":"AddLanguagePopup_select__1VCEt"};